import {Injectable} from '@angular/core';
import {Globals} from '../../global/globals';
import {HttpClient, HttpParams} from '@angular/common/http';
import {SearchUserResponse, User} from '../../dtos/user';
import {Observable} from 'rxjs';
import {ResetPwInfo} from '../../dtos/reset-pw-info';
import {UserSecurityEditDto} from '../../dtos/user/user-security-edit-dto';

@Injectable({
  providedIn: 'root'
})
export class UserService {

  private usersBaseUri: string = this.globals.backendUri + '/users';
  private registrationUri: string = this.usersBaseUri + '/registration';
  private resetPasswordUri: string = this.usersBaseUri + '/resetPassword';
  private currentUserUri: string = this.usersBaseUri + '/current';

  constructor(private httpClient: HttpClient, private globals: Globals) {
  }

  register(user: User) {
    return this.httpClient.post<User>(this.registrationUri, user);
  }

  resetPassword(mail: string): Observable<any> { // TODO check with Max
    let params = new HttpParams();
    params = params.append('email', mail);
    return this.httpClient.post<any>(this.resetPasswordUri, null, {params});
  }

  resetPasswordWithToken(password: string, token: string): Observable<any> {
    let params = new HttpParams();
    params = params.append('token', token);
    return this.httpClient.put<any>(this.resetPasswordUri, {password}, {params});
  }

  getCurrentUser(): Observable<User> {
    return this.httpClient.get<User>(this.currentUserUri);
  }

  searchUsers(params: HttpParams): Observable<SearchUserResponse> {
    return this.httpClient.get<SearchUserResponse>(this.usersBaseUri, {params});
  }

  getUserById(id: number): Observable<User> {
    return this.httpClient.get<User>(this.usersBaseUri + '/' + id);
  }

  updateUserSecurity(securityData: UserSecurityEditDto): Observable<User> {
    return this.httpClient.put<User>(this.usersBaseUri + '/' + securityData.id + '/security', securityData);
  }

  deleteUser(id: number): Observable<User> {
    return this.httpClient.delete<User>(this.usersBaseUri + '/' + id);
  }

  /**
   * deletes the own account, confirmed with email and password (admins delete other users with {@link deleteUser})
   */
  deleteOwnAccount(id: number, email: string, password: string): Observable<void> {
    return this.httpClient.request<void>('DELETE', this.usersBaseUri + '/' + id, {body: {email, password}});
  }

  changePassword(currentPw: string, newPw: string, id: number): Observable<User> {
    return this.httpClient.put<User>(this.usersBaseUri + '/' + id + '/password', new ResetPwInfo(currentPw, newPw));
  }

  editUser(user: User): Observable<User> {
    return this.httpClient.put<User>(this.usersBaseUri + '/' + user.id, user);
  }
}
